export const DOC_FLOW_EDIT_BUILDING_SCOPE_MODAL_QA_NAME =
  'docFlowEditBuildingScope'
